const gtag = (eventType, event, payload) => {
  try {
    if (typeof window === 'undefined') {
      return;
    }

    const _window = window;
    _window.gtag(eventType, event, payload);
  } catch (err) {
    console.log('google analytics is not ready!');
  }
};

const pushDataLayerEvent = (event, payload = {}) => {
  try {
    if (typeof window === 'undefined') {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event, ...payload});
  } catch (err) {
    console.log('dataLayer is not ready!');
  }
};

const tracker = {
  sendContact: () => {
    gtag('event', 'conversion', {
      send_to: 'AW-17012585194/BRYGCIaRg_8aEOrlnbA_',
    });
  },
  sendConsultationSubmitSuccess: () => {
    pushDataLayerEvent('consultation_submit_success');
  },
  sendLineClick: (clinic) => {
    pushDataLayerEvent('line_click', {clinic});
  },
  sendMessengerClick: (clinic) => {
    pushDataLayerEvent('messenger_click', {clinic});
  },
};

export default tracker;
